import { StoreState } from '@/core/models/store.interface';
import { ActionContext } from 'vuex';
import { ConfirmModalData } from './modal.interface';

export interface ModalState {
   showConfirmModal: boolean;
   confirmModalData?: ConfirmModalData;
}

const state: ModalState = {
   showConfirmModal: false,
};

const getters = {
   showConfirmModal(state: ModalState) {
      return state.showConfirmModal;
   },
   confirmModalData(state: ModalState) {
      return state.confirmModalData;
   },
};

const mutations = {
   SET_SHOW_CONFIRM_MODAL(state: ModalState, value: boolean) {
      state.showConfirmModal = value;
   },
   SET_CONFIRM_MODAL_DATA(state: ModalState, value?: ConfirmModalData) {
      state.confirmModalData = value;
   },
};

const actions = {
   promptConfirmation(context: ActionContext<ModalState, StoreState>, confirmModalData: ConfirmModalData) {
      context.commit('SET_SHOW_CONFIRM_MODAL', true);
      context.commit('SET_CONFIRM_MODAL_DATA', confirmModalData);
   },
   closeConfirmation(context: ActionContext<ModalState, StoreState>) {
      context.commit('SET_SHOW_CONFIRM_MODAL', false);
      context.commit('SET_CONFIRM_MODAL_DATA', null);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
